module.exports = __webpack_public_path__ + "static/img/rank-bg.9c824dc3.png";